'use strict';

var _assertThisInitialized = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _defineProperty = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/dmarcey/myApp/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var loader = require('@ionic/core/loader');

var React = _interopDefault(require('react'));

var tslib_1 = require('tslib');

var ReactDom = _interopDefault(require('react-dom'));

var core = require('@ionic/core');

var reactRouter = require('react-router');

var reactRouterDom = require('react-router-dom');

var ionicons = require('ionicons');

var icons = require('ionicons/icons');

function attachEventProps(node, newProps) {
  var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var className = getClassName(node.classList, newProps, oldProps);

  if (className) {
    node.className = className;
  }

  Object.keys(newProps).forEach(function (name) {
    if (name === 'children' || name === 'style' || name === 'ref' || name === 'className') {
      return;
    }

    if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
      var eventName = name.substring(2);
      var eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);

      if (!isCoveredByReact(eventNameLc)) {
        syncEvent(node, eventNameLc, newProps[name]);
      }
    } else {
      node[name] = newProps[name];
    }
  });
}

function getClassName(classList, newProps, oldProps) {
  // map the classes to Maps for performance
  var currentClasses = arrayToMap(classList);
  var incomingPropClasses = arrayToMap(newProps.className ? newProps.className.split(' ') : []);
  var oldPropClasses = arrayToMap(oldProps.className ? oldProps.className.split(' ') : []);
  var finalClassNames = []; // loop through each of the current classes on the component
  // to see if it should be a part of the classNames added

  currentClasses.forEach(function (currentClass) {
    if (incomingPropClasses.has(currentClass)) {
      // add it as its already included in classnames coming in from newProps
      finalClassNames.push(currentClass);
      incomingPropClasses.delete(currentClass);
    } else if (!oldPropClasses.has(currentClass)) {
      // add it as it has NOT been removed by user
      finalClassNames.push(currentClass);
    }
  });
  incomingPropClasses.forEach(function (s) {
    return finalClassNames.push(s);
  });
  return finalClassNames.join(' ');
}
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */


function isCoveredByReact(eventNameSuffix) {
  var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in doc;

  if (!isSupported) {
    var element = doc.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  return isSupported;
}

function syncEvent(node, eventName, newEventHandler) {
  var eventStore = node.__events || (node.__events = {});
  var oldEventHandler = eventStore[eventName]; // Remove old listener so they don't double up.

  if (oldEventHandler) {
    node.removeEventListener(eventName, oldEventHandler);
  } // Bind new listener.


  node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
    newEventHandler.call(this, e);
  });
}

function arrayToMap(arr) {
  var map = new Map();
  arr.forEach(function (s) {
    return map.set(s, s);
  });
  return map;
}

var IonicContext =
/*@__PURE__*/
React.createContext({
  getConfig: function getConfig() {},
  setConfig: function setConfig() {},
  platform: undefined
});

var useIonicConfig = function useIonicConfig() {
  var value = React.useContext(IonicContext);
  var config = value.getConfig() || {};
  var hook = [config, value.setConfig];
  return hook;
};

var dashToPascalCase = function dashToPascalCase(str) {
  return str.toLowerCase().split('-').map(function (segment) {
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }).join('');
};

function generateUniqueId() {
  return ([1e7].toString() + -1e3.toString() + -4e3.toString() + -8e3.toString() + -1e11.toString()).replace(/[018]/g, function (c) {
    var random = crypto.getRandomValues(new Uint8Array(1));
    return (c ^ random[0] & 15 >> c / 4).toString(16);
  });
}

function createReactComponent(tagName) {
  var attributeValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var displayName = dashToPascalCase(tagName);

  var ReactComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ReactComponent, _React$Component);

    function ReactComponent(props) {
      _classCallCheck(this, ReactComponent);

      return _possibleConstructorReturn(this, _getPrototypeOf(ReactComponent).call(this, props));
    }

    _createClass(ReactComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentWillReceiveProps(this.props);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(props) {
        var node = ReactDom.findDOMNode(this);
        attachEventProps(node, props, this.props);
      }
    }, {
      key: "render",
      value: function render() {
        var _a = this.props,
            children = _a.children,
            forwardedRef = _a.forwardedRef,
            cProps = tslib_1.__rest(_a, ["children", "forwardedRef"]);

        var propsWithoutAttributeValues = Object.keys(cProps).reduce(function (oldValue, key) {
          if (attributeValues.indexOf(key) === -1) {
            oldValue[key] = cProps[key];
          }

          return oldValue;
        }, {});
        return React.createElement(tagName, Object.assign({}, propsWithoutAttributeValues, {
          ref: forwardedRef
        }), children);
      }
    }], [{
      key: "displayName",
      get: function get() {
        return displayName;
      }
    }]);

    return ReactComponent;
  }(React.Component);

  function forwardRef(props, ref) {
    return React.createElement(ReactComponent, Object.assign({}, props, {
      forwardedRef: ref
    }));
  }

  forwardRef.displayName = displayName;
  return React.forwardRef(forwardRef);
} // ionicons


var IonIcon =
/*@__PURE__*/
createReactComponent('ion-icon', ['icon']); // /*@__PURE__*/createReactComponent

var IonTabBarInner =
/*@__PURE__*/
createReactComponent('ion-tab-bar');
var IonRouterOutletInner =
/*@__PURE__*/
createReactComponent('ion-router-outlet');
var IonBackButtonInner =
/*@__PURE__*/
createReactComponent('ion-back-button');
var IonTab =
/*@__PURE__*/
createReactComponent('ion-tab');
var IonTabButton =
/*@__PURE__*/
createReactComponent('ion-tab-button');
var IonAnchor =
/*@__PURE__*/
createReactComponent('ion-anchor');
var IonAppInner =
/*@__PURE__*/
createReactComponent('ion-app');
var IonAvatar =
/*@__PURE__*/
createReactComponent('ion-avatar');
var IonBackdrop =
/*@__PURE__*/
createReactComponent('ion-backdrop');
var IonBadge =
/*@__PURE__*/
createReactComponent('ion-badge');
var IonButton =
/*@__PURE__*/
createReactComponent('ion-button');
var IonButtons =
/*@__PURE__*/
createReactComponent('ion-buttons');
var IonCard =
/*@__PURE__*/
createReactComponent('ion-card');
var IonCardContent =
/*@__PURE__*/
createReactComponent('ion-card-content');
var IonCardHeader =
/*@__PURE__*/
createReactComponent('ion-card-header');
var IonCardSubtitle =
/*@__PURE__*/
createReactComponent('ion-card-subtitle');
var IonCardTitle =
/*@__PURE__*/
createReactComponent('ion-card-title');
var IonCheckbox =
/*@__PURE__*/
createReactComponent('ion-checkbox');
var IonCol =
/*@__PURE__*/
createReactComponent('ion-col');
var IonContent =
/*@__PURE__*/
createReactComponent('ion-content');
var IonChip =
/*@__PURE__*/
createReactComponent('ion-chip');
var IonDatetime =
/*@__PURE__*/
createReactComponent('ion-datetime');
var IonFab =
/*@__PURE__*/
createReactComponent('ion-fab');
var IonFabButton =
/*@__PURE__*/
createReactComponent('ion-fab-button');
var IonFabList =
/*@__PURE__*/
createReactComponent('ion-fab-list');
var IonFooter =
/*@__PURE__*/
createReactComponent('ion-footer');
var IonGrid =
/*@__PURE__*/
createReactComponent('ion-grid');
var IonHeader =
/*@__PURE__*/
createReactComponent('ion-header');
var IonImg =
/*@__PURE__*/
createReactComponent('ion-img');
var IonInfiniteScroll =
/*@__PURE__*/
createReactComponent('ion-infinite-scroll');
var IonInput =
/*@__PURE__*/
createReactComponent('ion-input');
var IonItem =
/*@__PURE__*/
createReactComponent('ion-item');
var IonItemDivider =
/*@__PURE__*/
createReactComponent('ion-item-divider');
var IonItemGroup =
/*@__PURE__*/
createReactComponent('ion-item-group');
var IonItemOption =
/*@__PURE__*/
createReactComponent('ion-item-option');
var IonItemOptions =
/*@__PURE__*/
createReactComponent('ion-item-options');
var IonItemSliding =
/*@__PURE__*/
createReactComponent('ion-item-sliding');
var IonLabel =
/*@__PURE__*/
createReactComponent('ion-label');
var IonList =
/*@__PURE__*/
createReactComponent('ion-list');
var IonListHeader =
/*@__PURE__*/
createReactComponent('ion-list-header');
var IonMenu =
/*@__PURE__*/
createReactComponent('ion-menu');
var IonMenuButton =
/*@__PURE__*/
createReactComponent('ion-menu-button');
var IonMenuToggle =
/*@__PURE__*/
createReactComponent('ion-menu-toggle');
var IonNote =
/*@__PURE__*/
createReactComponent('ion-note');
var IonPicker =
/*@__PURE__*/
createReactComponent('ion-picker');
var IonPickerColumn =
/*@__PURE__*/
createReactComponent('ion-picker-column');
var IonNav =
/*@__PURE__*/
createReactComponent('ion-nav');
var IonProgressBar =
/*@__PURE__*/
createReactComponent('ion-progress-bar');
var IonRadio =
/*@__PURE__*/
createReactComponent('ion-radio');
var IonRadioGroup =
/*@__PURE__*/
createReactComponent('ion-radio-group');
var IonRange =
/*@__PURE__*/
createReactComponent('ion-range');
var IonRefresher =
/*@__PURE__*/
createReactComponent('ion-refresher');
var IonRefresherContent =
/*@__PURE__*/
createReactComponent('ion-refresher-content');
var IonReorder =
/*@__PURE__*/
createReactComponent('ion-reorder');
var IonReorderGroup =
/*@__PURE__*/
createReactComponent('ion-reorder-group');
var IonRippleEffect =
/*@__PURE__*/
createReactComponent('ion-ripple-effect');
var IonRow =
/*@__PURE__*/
createReactComponent('ion-row');
var IonSearchbar =
/*@__PURE__*/
createReactComponent('ion-searchbar');
var IonSegment =
/*@__PURE__*/
createReactComponent('ion-segment');
var IonSegmentButton =
/*@__PURE__*/
createReactComponent('ion-segment-button');
var IonSelect =
/*@__PURE__*/
createReactComponent('ion-select');
var IonSelectOption =
/*@__PURE__*/
createReactComponent('ion-select-option');
var IonSelectPopover =
/*@__PURE__*/
createReactComponent('ion-select-popover');
var IonSkeletonText =
/*@__PURE__*/
createReactComponent('ion-skeleton-text');
var IonSlide =
/*@__PURE__*/
createReactComponent('ion-slide');
var IonSlides =
/*@__PURE__*/
createReactComponent('ion-slides');
var IonSpinner =
/*@__PURE__*/
createReactComponent('ion-spinner');
var IonSplitPane =
/*@__PURE__*/
createReactComponent('ion-split-pane');
var IonText =
/*@__PURE__*/
createReactComponent('ion-text');
var IonTextarea =
/*@__PURE__*/
createReactComponent('ion-textarea');
var IonThumbnail =
/*@__PURE__*/
createReactComponent('ion-thumbnail');
var IonTitle =
/*@__PURE__*/
createReactComponent('ion-title');
var IonToggle =
/*@__PURE__*/
createReactComponent('ion-toggle');
var IonToolbar =
/*@__PURE__*/
createReactComponent('ion-toolbar');
var IonVirtualScroll =
/*@__PURE__*/
createReactComponent('ion-virtual-scroll');

var Platform =
/*#__PURE__*/
function () {
  function Platform() {
    _classCallCheck(this, Platform);
  }
  /**
   * @returns returns true/false based on platform.
   * @description
   * Depending on the platform the user is on, `is(platformName)` will
   * return `true` or `false`. Note that the same app can return `true`
   * for more than one platform name. For example, an app running from
   * an iPad would return `true` for the platform names: `mobile`,
   * `ios`, `ipad`, and `tablet`. Additionally, if the app was running
   * from Cordova then `cordova` would be true, and if it was running
   * from a web browser on the iPad then `mobileweb` would be `true`.
   *
   * ```
   * import { Platform } from 'ionic-angular';
   *
   * @Component({...})
   * export MyPage {
   *   constructor(public platform: Platform) {
   *     if (this.platform.is('ios')) {
   *       // This will only print when on iOS
   *       console.log('I am an iOS device!');
   *     }
   *   }
   * }
   * ```
   *
   * | Platform Name   | Description                        |
   * |-----------------|------------------------------------|
   * | android         | on a device running Android.       |
   * | cordova         | on a device running Cordova.       |
   * | ios             | on a device running iOS.           |
   * | ipad            | on an iPad device.                 |
   * | iphone          | on an iPhone device.               |
   * | phablet         | on a phablet device.               |
   * | tablet          | on a tablet device.                |
   * | electron        | in Electron on a desktop device.   |
   * | pwa             | as a PWA app.                      |
   * | mobile          | on a mobile device.                |
   * | mobileweb       | on a mobile device in a browser.   |
   * | desktop         | on a desktop device.               |
   * | hybrid          | is a cordova or capacitor app.     |
   *
   */


  _createClass(Platform, [{
    key: "is",
    value: function is(platformName) {
      return core.isPlatform(window, platformName);
    }
    /**
     * @returns the array of platforms
     * @description
     * Depending on what device you are on, `platforms` can return multiple values.
     * Each possible value is a hierarchy of platforms. For example, on an iPhone,
     * it would return `mobile`, `ios`, and `iphone`.
     *
     * ```
     * import { Platform } from 'ionic-angular';
     *
     * @Component({...})
     * export MyPage {
     *   constructor(public platform: Platform) {
     *     // This will print an array of the current platforms
     *     console.log(this.platform.platforms());
     *   }
     * }
     * ```
     */

  }, {
    key: "platforms",
    value: function platforms() {
      return core.getPlatforms(window);
    }
    /**
    * Returns if this app is using right-to-left language direction or not.
    * We recommend the app's `index.html` file already has the correct `dir`
    * attribute value set, such as `<html dir="ltr">` or `<html dir="rtl">`.
    * [W3C: Structural markup and right-to-left text in HTML](http://www.w3.org/International/questions/qa-html-dir)
    */

  }, {
    key: "getQueryParam",

    /**
    * Get the query string parameter
    */
    value: function getQueryParam(key) {
      return readQueryParam(window.location.href, key);
    }
    /**
     * Returns `true` if the app is in landscape mode.
     */

  }, {
    key: "isLandscape",
    value: function isLandscape() {
      return !this.isPortrait();
    }
    /**
    * Returns `true` if the app is in portait mode.
    */

  }, {
    key: "isPortrait",
    value: function isPortrait() {
      return window.matchMedia && window.matchMedia('(orientation: portrait)').matches;
    }
  }, {
    key: "testUserAgent",
    value: function testUserAgent(expression) {
      var nav = window.navigator;
      return !!(nav && nav.userAgent && nav.userAgent.indexOf(expression) >= 0);
    }
    /**
    * Get the current url.
    */

  }, {
    key: "url",
    value: function url() {
      return window.location.href;
    }
    /**
     * Gets the width of the platform's viewport using `window.innerWidth`.
     */

  }, {
    key: "width",
    value: function width() {
      return window.innerWidth;
    }
    /**
     * Gets the height of the platform's viewport using `window.innerHeight`.
     */

  }, {
    key: "height",
    value: function height() {
      return window.innerHeight;
    }
  }, {
    key: "isRTL",
    get: function get() {
      return document.dir === 'rtl';
    }
  }]);

  return Platform;
}();

var readQueryParam = function readQueryParam(url, key) {
  key = key.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + key + '=([^&#]*)');
  var results = regex.exec(url);
  return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
};

function getConfig() {
  var coreConfig = getCoreConfig();
  var config = Array.from(coreConfig.m).reduce(function (obj, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    obj[key] = value;
    return obj;
  }, {});
  return config;
}

function setConfig(config) {
  var coreConfig = getCoreConfig();
  coreConfig.reset(config);
}

function getCoreConfig() {
  if (typeof window !== 'undefined') {
    var Ionic = window.Ionic;

    if (Ionic && Ionic.config) {
      return window.Ionic.config;
    }
  }

  return null;
}

var IonApp =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(IonApp, _React$Component2);

  function IonApp(props) {
    var _this;

    _classCallCheck(this, IonApp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IonApp).call(this, props));
    var ionicPlatform = new Platform();
    _this.state = {
      getConfig: getConfig,
      setConfig: setConfig,
      platform: ionicPlatform
    };
    return _this;
  }

  _createClass(IonApp, [{
    key: "render",
    value: function render() {
      return React.createElement(IonicContext.Provider, {
        value: this.state
      }, React.createElement(IonAppInner, null, this.props.children));
    }
  }]);

  return IonApp;
}(React.Component);

function createControllerComponent(displayName, controller) {
  var dismissEventName = "on".concat(displayName, "DidDismiss");
  return (
    /*#__PURE__*/
    function (_React$Component3) {
      _inherits(ReactControllerComponent, _React$Component3);

      function ReactControllerComponent(props) {
        var _this2;

        _classCallCheck(this, ReactControllerComponent);

        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ReactControllerComponent).call(this, props));
        _this2.id = generateUniqueId();
        return _this2;
      }

      _createClass(ReactControllerComponent, [{
        key: "componentDidMount",
        value: function () {
          var _componentDidMount = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var isOpen;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    isOpen = this.props.isOpen;

                    if (isOpen) {
                      this.present();
                    }

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          return function componentDidMount() {
            return _componentDidMount.apply(this, arguments);
          };
        }()
      }, {
        key: "componentDidUpdate",
        value: function () {
          var _componentDidUpdate = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2(prevProps) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen === true) {
                      this.present(prevProps);
                    }

                    if (!(this.controller && prevProps.isOpen !== this.props.isOpen && this.props.isOpen === false)) {
                      _context2.next = 4;
                      break;
                    }

                    _context2.next = 4;
                    return this.controller.dismiss();

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          return function componentDidUpdate(_x) {
            return _componentDidUpdate.apply(this, arguments);
          };
        }()
      }, {
        key: "present",
        value: function () {
          var _present = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee3(prevProps) {
            var _a, isOpen, onDidDismiss, cProps, elementProps;

            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _a = this.props, isOpen = _a.isOpen, onDidDismiss = _a.onDidDismiss, cProps = tslib_1.__rest(_a, ["isOpen", "onDidDismiss"]);
                    elementProps = Object.assign({}, cProps, _defineProperty({}, dismissEventName, onDidDismiss));
                    _context3.next = 4;
                    return controller.create(Object.assign({}, elementProps));

                  case 4:
                    this.controller = _context3.sent;
                    attachEventProps(this.controller, elementProps, prevProps);
                    this.controller.present();

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));

          return function present(_x2) {
            return _present.apply(this, arguments);
          };
        }()
      }, {
        key: "render",
        value: function render() {
          return null;
        }
      }], [{
        key: "displayName",
        get: function get() {
          return displayName;
        }
      }]);

      return ReactControllerComponent;
    }(React.Component)
  );
}

var IonAlert =
/*@__PURE__*/
createControllerComponent('IonAlert', core.alertController);
var IonLoading =
/*@__PURE__*/
createControllerComponent('IonLoading', core.loadingController);
var IonToast =
/*@__PURE__*/
createControllerComponent('IonToast', core.toastController);

function createOverlayComponent(displayName, controller) {
  var dismissEventName = "on".concat(displayName, "DidDismiss");
  return (
    /*#__PURE__*/
    function (_React$Component4) {
      _inherits(ReactOverlayComponent, _React$Component4);

      function ReactOverlayComponent(props) {
        var _this3;

        _classCallCheck(this, ReactOverlayComponent);

        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ReactOverlayComponent).call(this, props));
        _this3.el = document.createElement('div');
        return _this3;
      }

      _createClass(ReactOverlayComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.props.isOpen) {
            this.present();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function () {
          var _componentDidUpdate2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4(prevProps) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen === true) {
                      this.present(prevProps);
                    }

                    if (!(this.controller && prevProps.isOpen !== this.props.isOpen && this.props.isOpen === false)) {
                      _context4.next = 4;
                      break;
                    }

                    _context4.next = 4;
                    return this.controller.dismiss();

                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          return function componentDidUpdate(_x3) {
            return _componentDidUpdate2.apply(this, arguments);
          };
        }()
      }, {
        key: "present",
        value: function () {
          var _present2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee5(prevProps) {
            var _a, children, isOpen, _a$onDidDismiss, onDidDismiss, cProps, elementProps;

            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _a = this.props, children = _a.children, isOpen = _a.isOpen, _a$onDidDismiss = _a.onDidDismiss, onDidDismiss = _a$onDidDismiss === void 0 ? function () {} : _a$onDidDismiss, cProps = tslib_1.__rest(_a, ["children", "isOpen", "onDidDismiss"]);
                    elementProps = Object.assign({}, cProps, _defineProperty({}, dismissEventName, onDidDismiss));
                    _context5.next = 4;
                    return controller.create(Object.assign({}, elementProps, {
                      component: this.el,
                      componentProps: {}
                    }));

                  case 4:
                    this.controller = _context5.sent;
                    attachEventProps(this.controller, elementProps, prevProps);
                    this.controller.present();

                  case 7:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));

          return function present(_x4) {
            return _present2.apply(this, arguments);
          };
        }()
      }, {
        key: "render",
        value: function render() {
          return ReactDom.createPortal(this.props.children, this.el);
        }
      }], [{
        key: "displayName",
        get: function get() {
          return displayName;
        }
      }]);

      return ReactOverlayComponent;
    }(React.Component)
  );
}

var IonActionSheet =
/*@__PURE__*/
createOverlayComponent('IonActionSheet', core.actionSheetController);
var IonModal =
/*@__PURE__*/
createOverlayComponent('IonModal', core.modalController);
var IonPopover =
/*@__PURE__*/
createOverlayComponent('IonPopover', core.popoverController);

var IonPageInternal = function IonPageInternal(_a) {
  var children = _a.children,
      forwardedRef = _a.forwardedRef,
      className = _a.className,
      props = tslib_1.__rest(_a, ["children", "forwardedRef", "className"]);

  return React.createElement("div", Object.assign({
    className: className ? "ion-page ".concat(className) : 'ion-page',
    ref: forwardedRef
  }, props), children);
};

function forwardRef(props, ref) {
  return React.createElement(IonPageInternal, Object.assign({}, props, {
    forwardedRef: ref
  }));
}

forwardRef.displayName = 'IonPage';
var IonPage =
/*@__PURE__*/
React.forwardRef(forwardRef);

var TabBar =
/*#__PURE__*/
function (_React$Component5) {
  _inherits(TabBar, _React$Component5);

  function TabBar(props) {
    var _this4;

    _classCallCheck(this, TabBar);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(TabBar).call(this, props));

    _this4.onTabButtonClick = function (e) {
      var targetUrl = _this4.state.activeTab === e.detail.tab ? _this4.state.tabs[e.detail.tab].originalHref : _this4.state.tabs[e.detail.tab].currentHref;

      _this4.props.history.push(targetUrl);
    };

    _this4.renderChild = function (activeTab) {
      return function (child) {
        if (child != null && typeof child === 'object' && child.props && child.type === IonTabButton) {
          var href = child.props.tab === activeTab ? _this4.props.location.pathname : _this4.state.tabs[child.props.tab].currentHref;
          return React.cloneElement(child, {
            href: href,
            onIonTabButtonClick: _this4.onTabButtonClick
          });
        }

        return null;
      };
    };

    var tabActiveUrls = {};
    React.Children.forEach(_this4.props.children, function (child) {
      if (child != null && typeof child === 'object' && child.props && child.type === IonTabButton) {
        tabActiveUrls[child.props.tab] = {
          originalHref: child.props.href,
          currentHref: child.props.href
        };
      }
    });
    _this4.state = {
      activeTab: null,
      tabs: tabActiveUrls
    };
    return _this4;
  }

  _createClass(TabBar, [{
    key: "render",
    value: function render() {
      return React.createElement(IonTabBarInner, Object.assign({}, this.props, {
        selectedTab: this.state.activeTab
      }), React.Children.map(this.props.children, this.renderChild(this.state.activeTab)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var activeTab = Object.keys(state.tabs).find(function (key) {
        var href = state.tabs[key].originalHref;
        return props.location.pathname.startsWith(href);
      });

      if (!activeTab || activeTab === state.activeTab && state.tabs[activeTab].currentHref === props.location.pathname) {
        return null;
      }

      return {
        activeTab: activeTab,
        tabs: Object.assign({}, state.tabs, _defineProperty({}, activeTab, {
          originalHref: state.tabs[activeTab].originalHref,
          currentHref: props.location.pathname
        }))
      };
    }
  }]);

  return TabBar;
}(React.Component);

var IonTabBar =
/*@__PURE__*/
reactRouter.withRouter(TabBar);

function generateUniqueId$1() {
  return ([1e7].toString() + -1e3.toString() + -4e3.toString() + -8e3.toString() + -1e11.toString()).replace(/[018]/g, function (c) {
    var random = crypto.getRandomValues(new Uint8Array(1));
    return (c ^ random[0] & 15 >> c / 4).toString(16);
  });
}

var IonLifeCycleContext = React.createContext({
  onIonViewWillEnter: function onIonViewWillEnter() {},
  ionViewWillEnter: function ionViewWillEnter() {},
  onIonViewDidEnter: function onIonViewDidEnter() {},
  ionViewDidEnter: function ionViewDidEnter() {},
  onIonViewWillLeave: function onIonViewWillLeave() {},
  ionViewWillLeave: function ionViewWillLeave() {},
  onIonViewDidLeave: function onIonViewDidLeave() {},
  ionViewDidLeave: function ionViewDidLeave() {}
});

var DefaultIonLifeCycleContext =
/*#__PURE__*/
function () {
  function DefaultIonLifeCycleContext() {
    _classCallCheck(this, DefaultIonLifeCycleContext);
  }

  _createClass(DefaultIonLifeCycleContext, [{
    key: "onIonViewWillEnter",
    value: function onIonViewWillEnter(callback) {
      this.ionViewWillEnterCallback = callback;
    }
  }, {
    key: "ionViewWillEnter",
    value: function ionViewWillEnter() {
      if (this.ionViewWillEnterCallback) {
        this.ionViewWillEnterCallback();
      }
    }
  }, {
    key: "onIonViewDidEnter",
    value: function onIonViewDidEnter(callback) {
      this.ionViewDidEnterCallback = callback;
    }
  }, {
    key: "ionViewDidEnter",
    value: function ionViewDidEnter() {
      if (this.ionViewDidEnterCallback) {
        this.ionViewDidEnterCallback();
      }
    }
  }, {
    key: "onIonViewWillLeave",
    value: function onIonViewWillLeave(callback) {
      this.ionViewWillLeaveCallback = callback;
    }
  }, {
    key: "ionViewWillLeave",
    value: function ionViewWillLeave() {
      if (this.ionViewWillLeaveCallback) {
        this.ionViewWillLeaveCallback();
      }
    }
  }, {
    key: "onIonViewDidLeave",
    value: function onIonViewDidLeave(callback) {
      this.ionViewDidLeaveCallback = callback;
    }
  }, {
    key: "ionViewDidLeave",
    value: function ionViewDidLeave() {
      if (this.ionViewDidLeaveCallback) {
        this.ionViewDidLeaveCallback();
      }

      this.componentCanBeDestroyed();
    }
  }, {
    key: "onComponentCanBeDestroyed",
    value: function onComponentCanBeDestroyed(callback) {
      this.componentCanBeDestroyedCallback = callback;
    }
  }, {
    key: "componentCanBeDestroyed",
    value: function componentCanBeDestroyed() {
      if (this.componentCanBeDestroyedCallback) {
        this.componentCanBeDestroyedCallback();
      }
    }
  }]);

  return DefaultIonLifeCycleContext;
}();

var ViewInternal =
/*#__PURE__*/
function (_React$Component6) {
  _inherits(ViewInternal, _React$Component6);

  function ViewInternal(props) {
    var _this5;

    _classCallCheck(this, ViewInternal);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ViewInternal).call(this, props));
    _this5.state = {
      ref: null
    };
    return _this5;
  }

  _createClass(ViewInternal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var forwardedRef = this.props.forwardedRef;
      this.setState({
        ref: forwardedRef
      });

      if (forwardedRef && forwardedRef.current) {
        forwardedRef.current.addEventListener('ionViewWillEnter', this.ionViewWillEnterHandler.bind(this));
        forwardedRef.current.addEventListener('ionViewDidEnter', this.ionViewDidEnterHandler.bind(this));
        forwardedRef.current.addEventListener('ionViewWillLeave', this.ionViewWillLeaveHandler.bind(this));
        forwardedRef.current.addEventListener('ionViewDidLeave', this.ionViewDidLeaveHandler.bind(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var forwardedRef = this.props.forwardedRef;

      if (forwardedRef && forwardedRef.current) {
        forwardedRef.current.removeEventListener('ionViewWillEnter', this.ionViewWillEnterHandler.bind(this));
        forwardedRef.current.removeEventListener('ionViewDidEnter', this.ionViewDidEnterHandler.bind(this));
        forwardedRef.current.removeEventListener('ionViewWillLeave', this.ionViewWillLeaveHandler.bind(this));
        forwardedRef.current.removeEventListener('ionViewDidLeave', this.ionViewDidLeaveHandler.bind(this));
      }
    }
  }, {
    key: "ionViewWillEnterHandler",
    value: function ionViewWillEnterHandler() {
      this.context.ionViewWillEnter();
    }
  }, {
    key: "ionViewDidEnterHandler",
    value: function ionViewDidEnterHandler() {
      this.context.ionViewDidEnter();
    }
  }, {
    key: "ionViewWillLeaveHandler",
    value: function ionViewWillLeaveHandler() {
      this.context.ionViewWillLeave();
    }
  }, {
    key: "ionViewDidLeaveHandler",
    value: function ionViewDidLeaveHandler() {
      this.context.ionViewDidLeave();
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          children = _a.children,
          forwardedRef = _a.forwardedRef,
          rest = tslib_1.__rest(_a, ["className", "children", "forwardedRef"]);

      var ref = this.state.ref;
      return React.createElement("div", Object.assign({
        className: className ? "ion-page ".concat(className) : 'ion-page',
        ref: forwardedRef
      }, rest), ref && children);
    }
  }]);

  return ViewInternal;
}(React.Component);

ViewInternal.contextType = IonLifeCycleContext;

function forwardRef$1(props, ref) {
  return React.createElement(ViewInternal, Object.assign({
    forwardedRef: ref
  }, props));
}

forwardRef$1.displayName = 'View';
var View =
/*@__PURE__*/
React.forwardRef(forwardRef$1);
var NavContext =
/*@__PURE__*/
React.createContext({
  viewStacks: {},
  hideView: function hideView() {
    navContextNotFoundError();
  },
  goBack: function goBack() {
    navContextNotFoundError();
  },
  setupIonRouter: function setupIonRouter() {
    navContextNotFoundError();
  },
  removeViewStack: function removeViewStack() {
    navContextNotFoundError();
  },
  renderChild: function renderChild() {
    navContextNotFoundError();
  },
  transitionView: function transitionView() {
    navContextNotFoundError();
  }
});

function navContextNotFoundError() {
  console.error('IonRouter not found, did you add it to the app?');
}

var withIonLifeCycle = function withIonLifeCycle(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component7) {
      _inherits(IonLifeCycle, _React$Component7);

      function IonLifeCycle(props) {
        var _this6;

        _classCallCheck(this, IonLifeCycle);

        _this6 = _possibleConstructorReturn(this, _getPrototypeOf(IonLifeCycle).call(this, props));
        _this6.componentRef = React.createRef();
        return _this6;
      }

      _createClass(IonLifeCycle, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this7 = this;

          this.context.onIonViewWillEnter(function () {
            if (_this7.componentRef.current.ionViewWillEnter) {
              _this7.componentRef.current.ionViewWillEnter();
            }
          });
          this.context.onIonViewDidEnter(function () {
            if (_this7.componentRef.current.ionViewDidEnter) {
              _this7.componentRef.current.ionViewDidEnter();
            }
          });
          this.context.onIonViewWillLeave(function () {
            if (_this7.componentRef.current.ionViewWillLeave) {
              _this7.componentRef.current.ionViewWillLeave();
            }
          });
          this.context.onIonViewDidLeave(function () {
            if (_this7.componentRef.current.ionViewDidLeave) {
              _this7.componentRef.current.ionViewDidLeave();
            }
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this8 = this;

          return React.createElement(IonLifeCycleContext.Consumer, null, function (context) {
            _this8.context = context;
            return React.createElement(WrappedComponent, Object.assign({
              ref: _this8.componentRef
            }, _this8.props));
          });
        }
      }]);

      return IonLifeCycle;
    }(React.Component)
  );
};

var useIonViewWillEnter = function useIonViewWillEnter(callback) {
  var value = React.useContext(IonLifeCycleContext);
  value.onIonViewWillEnter(callback);
};

var useIonViewDidEnter = function useIonViewDidEnter(callback) {
  var value = React.useContext(IonLifeCycleContext);
  value.onIonViewDidEnter(callback);
};

var useIonViewWillLeave = function useIonViewWillLeave(callback) {
  var value = React.useContext(IonLifeCycleContext);
  value.onIonViewWillLeave(callback);
};

var useIonViewDidLeave = function useIonViewDidLeave(callback) {
  var value = React.useContext(IonLifeCycleContext);
  value.onIonViewDidLeave(callback);
};

var ViewItemManager =
/*#__PURE__*/
function (_React$Component8) {
  _inherits(ViewItemManager, _React$Component8);

  function ViewItemManager(props) {
    var _this9;

    _classCallCheck(this, ViewItemManager);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(ViewItemManager).call(this, props));
    _this9.ionLifeCycleContext = new DefaultIonLifeCycleContext();
    _this9._isMounted = false;
    _this9.state = {
      show: true
    };

    _this9.ionLifeCycleContext.onComponentCanBeDestroyed(function () {
      if (!_this9.props.mount) {
        if (_this9._isMounted) {
          _this9.setState({
            show: false
          }, function () {
            _this9.context.hideView(_this9.props.id);
          });
        }
      }
    });

    return _this9;
  }

  _createClass(ViewItemManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var show = this.state.show;
      return React.createElement(IonLifeCycleContext.Provider, {
        value: this.ionLifeCycleContext
      }, show && this.props.children);
    }
  }]);

  return ViewItemManager;
}(React.Component); // TODO: treeshake


ViewItemManager.contextType = NavContext;

var IonRouterOutlet =
/*#__PURE__*/
function (_React$Component9) {
  _inherits(IonRouterOutlet, _React$Component9);

  function IonRouterOutlet(props) {
    var _this10;

    _classCallCheck(this, IonRouterOutlet);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(IonRouterOutlet).call(this, props));
    _this10.containerEl = React.createRef();
    _this10.id = _this10.props.id || generateUniqueId$1();
    return _this10;
  }

  _createClass(IonRouterOutlet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.setupIonRouter(this.id, this.props.children, this.containerEl.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.removeViewStack(this.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      return React.createElement(NavContext.Consumer, null, function (context) {
        _this11.context = context;
        var viewStack = context.viewStacks[_this11.id];
        var activeId = viewStack ? viewStack.activeId : '';
        var views = (viewStack || {
          views: []
        }).views.filter(function (x) {
          return x.show;
        });
        return React.createElement(IonRouterOutletInner, {
          "data-id": _this11.id,
          ref: _this11.containerEl
        }, views.map(function (item) {
          var props = {};

          if (item.id === activeId) {
            props = {
              'className': ' ion-page-invisible'
            };
          }

          return React.createElement(ViewItemManager, {
            id: item.id,
            key: item.key,
            mount: item.mount
          }, React.createElement(View, Object.assign({
            ref: item.ref
          }, props), _this11.context.renderChild(item)));
        }));
      });
    }
  }]);

  return IonRouterOutlet;
}(React.Component);

var hostStyles = {
  display: 'flex',
  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  contain: 'layout size style'
};
var tabsInner = {
  position: 'relative',
  flex: 1,
  contain: 'layout size style'
};

var IonTabs =
/*#__PURE__*/
function (_React$Component10) {
  _inherits(IonTabs, _React$Component10);

  function IonTabs() {
    _classCallCheck(this, IonTabs);

    return _possibleConstructorReturn(this, _getPrototypeOf(IonTabs).apply(this, arguments));
  }

  _createClass(IonTabs, [{
    key: "render",
    value: function render() {
      var outlet;
      var tabBar;
      React.Children.forEach(this.props.children, function (child) {
        if (child == null || typeof child !== 'object' || !child.hasOwnProperty('type')) {
          return;
        }

        if (child.type === IonRouterOutlet) {
          outlet = child;
        }

        if (child.type === IonTabBar) {
          tabBar = child;
        }
      });
      return React.createElement("div", {
        style: hostStyles
      }, tabBar.props.slot === 'top' ? tabBar : null, React.createElement("div", {
        style: tabsInner,
        className: "tabs-inner"
      }, outlet), tabBar.props.slot === 'bottom' ? tabBar : null);
    }
  }]);

  return IonTabs;
}(React.Component);

var IonBackButton =
/*#__PURE__*/
function (_React$Component11) {
  _inherits(IonBackButton, _React$Component11);

  function IonBackButton() {
    var _this12;

    _classCallCheck(this, IonBackButton);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(IonBackButton).apply(this, arguments));

    _this12.clickButton = function (e) {
      e.stopPropagation();

      _this12.context.goBack(_this12.props.defaultHref);
    };

    return _this12;
  }

  _createClass(IonBackButton, [{
    key: "render",
    value: function render() {
      return React.createElement(IonBackButtonInner, Object.assign({
        onClick: this.clickButton
      }, this.props));
    }
  }]);

  return IonBackButton;
}(React.Component);

IonBackButton.contextType = NavContext;

var IonNavManager =
/*#__PURE__*/
function (_React$Component12) {
  _inherits(IonNavManager, _React$Component12);

  function IonNavManager(props) {
    var _this13;

    _classCallCheck(this, IonNavManager);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(IonNavManager).call(this, props));

    _this13.goBack = function (defaultHref) {
      var _this13$findViewInfoB = _this13.findViewInfoByLocation(_this13.props.location, _this13.state.viewStacks),
          leavingView = _this13$findViewInfoB.view;

      if (leavingView) {
        var _this13$findViewInfoB2 = _this13.findViewInfoById(leavingView.prevId, _this13.state.viewStacks),
            enteringView = _this13$findViewInfoB2.view;

        if (enteringView) {
          _this13.props.history.replace(enteringView.routeData.match.url, {
            direction: 'back'
          });
        } else {
          _this13.props.history.replace(defaultHref, {
            direction: 'back'
          });
        }
      } else {
        _this13.props.history.replace(defaultHref, {
          direction: 'back'
        });
      }
    };

    _this13.state = {
      viewStacks: {},
      hideView: _this13.hideView.bind(_assertThisInitialized(_assertThisInitialized(_this13))),
      setupIonRouter: _this13.setupIonRouter.bind(_assertThisInitialized(_assertThisInitialized(_this13))),
      removeViewStack: _this13.removeViewStack.bind(_assertThisInitialized(_assertThisInitialized(_this13))),
      renderChild: _this13.renderChild.bind(_assertThisInitialized(_assertThisInitialized(_this13))),
      goBack: _this13.goBack.bind(_assertThisInitialized(_assertThisInitialized(_this13))),
      transitionView: _this13.transitionView.bind(_assertThisInitialized(_assertThisInitialized(_this13)))
    };
    return _this13;
  }

  _createClass(IonNavManager, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.listenUnregisterCallback = this.props.history.listen(this.historyChange.bind(this));
    }
  }, {
    key: "hideView",
    value: function hideView(viewId) {
      var viewStacks = Object.assign({}, this.state.viewStacks);

      var _this$findViewInfoByI = this.findViewInfoById(viewId, viewStacks),
          view = _this$findViewInfoByI.view;

      if (view) {
        view.show = false;
        view.key = generateUniqueId();
        this.setState({
          viewStacks: viewStacks
        });
      }
    }
  }, {
    key: "historyChange",
    value: function historyChange(location, action) {
      this.setActiveView(location, action);
    }
  }, {
    key: "findViewInfoByLocation",
    value: function findViewInfoByLocation(location, viewStacks) {
      var view;
      var match;
      var viewStack;
      var keys = Object.keys(viewStacks);
      keys.some(function (key) {
        var vs = viewStacks[key];
        return vs.views.some(function (x) {
          match = reactRouterDom.matchPath(location.pathname, x.routeData.childProps);

          if (match) {
            view = x;
            viewStack = vs;
            return true;
          }

          return false;
        });
      });
      var result = {
        view: view,
        viewStack: viewStack,
        match: match
      };
      return result;
    }
  }, {
    key: "findViewInfoById",
    value: function findViewInfoById(id, viewStacks) {
      var view;
      var viewStack;
      var keys = Object.keys(viewStacks);
      keys.some(function (key) {
        var vs = viewStacks[key];
        view = vs.views.find(function (x) {
          return x.id === id;
        });

        if (view) {
          viewStack = vs;
          return true;
        } else {
          return false;
        }
      });
      return {
        view: view,
        viewStack: viewStack
      };
    }
  }, {
    key: "setActiveView",
    value: function setActiveView(location, action) {
      var _this14 = this;

      var viewStacks = Object.assign({}, this.state.viewStacks);

      var _this$findViewInfoByL = this.findViewInfoByLocation(location, viewStacks),
          enteringView = _this$findViewInfoByL.view,
          enteringViewStack = _this$findViewInfoByL.viewStack,
          match = _this$findViewInfoByL.match;

      var direction = location.state && location.state.direction;

      if (!enteringViewStack) {
        return;
      }

      var _this$findViewInfoByI2 = this.findViewInfoById(this.activeViewId, viewStacks),
          leavingView = _this$findViewInfoByI2.view;

      if (leavingView && leavingView.routeData.match.url === location.pathname) {
        return;
      }

      if (enteringView) {
        /**
         * If the page is being pushed into the stack by another view,
         * record the view that originally directed to the new view for back button purposes.
         */
        if (!enteringView.show && action === 'PUSH') {
          enteringView.prevId = leavingView && leavingView.id;
        }

        enteringView.show = true;
        enteringView.mount = true;
        enteringView.routeData.match = match;
        enteringViewStack.activeId = enteringView.id;
        this.activeViewId = enteringView.id;

        if (leavingView) {
          this.prevViewId = leavingView.id;

          if (leavingView.routeData.match.params.tab === enteringView.routeData.match.params.tab) {
            if (action === 'PUSH') {
              direction = direction || 'forward';
            } else {
              direction = direction || 'back';
              leavingView.mount = false;
            }
          }
          /**
           * Attempt to determine if the leaving view is a route redirect.
           * If it is, take it out of the rendering phase.
           * We assume Routes with render props are redirects, because of this users should not use
           * the render prop for non redirects, and instead provide a component in its place.
           */


          if (leavingView.element.type === reactRouterDom.Redirect || leavingView.element.props.render) {
            leavingView.mount = false;
            leavingView.show = false;
          }
        }

        this.setState({
          viewStacks: viewStacks
        }, function () {
          var enteringEl = enteringView.ref && enteringView.ref.current ? enteringView.ref.current : undefined;
          var leavingEl = leavingView && leavingView.ref && leavingView.ref.current ? leavingView.ref.current : undefined;

          _this14.transitionView(enteringEl, leavingEl, enteringViewStack.routerOutlet, direction);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.listenUnregisterCallback();
    }
  }, {
    key: "setupIonRouter",
    value: function setupIonRouter(id, children, routerOutlet) {
      var _this15 = this;

      var views = [];
      var activeId;
      React.Children.forEach(children, function (child) {
        if (child.type === reactRouterDom.Switch) {
          /**
           * If the first child is a Switch, loop through its children to build the viewStack
           */
          React.Children.forEach(child.props.children, function (grandChild) {
            addView.call(_this15, grandChild);
          });
        } else {
          addView.call(_this15, child);
        }
      });
      this.registerViewStack(id, activeId, views, routerOutlet, this.props.location);

      function addView(child) {
        var location = this.props.history.location;
        var viewId = generateUniqueId();
        var key = generateUniqueId();
        var element = child;
        var match = reactRouterDom.matchPath(location.pathname, child.props);
        var view = {
          id: viewId,
          key: key,
          routeData: {
            match: match,
            childProps: child.props
          },
          element: element,
          mount: true,
          show: !!match,
          ref: React.createRef()
        };

        if (!!match) {
          activeId = viewId;
        }

        views.push(view);
        return activeId;
      }
    }
  }, {
    key: "registerViewStack",
    value: function registerViewStack(stack, activeId, stackItems, routerOutlet, location) {
      var _this16 = this;

      this.setState(function (prevState) {
        var prevViewStacks = Object.assign({}, prevState.viewStacks);
        prevViewStacks[stack] = {
          activeId: activeId,
          views: stackItems,
          routerOutlet: routerOutlet
        };
        return {
          viewStacks: prevViewStacks
        };
      }, function () {
        var _this16$findViewInfoB = _this16.findViewInfoById(activeId, _this16.state.viewStacks),
            activeView = _this16$findViewInfoB.view;

        if (activeView) {
          _this16.prevViewId = _this16.activeViewId;
          _this16.activeViewId = activeView.id;
          var direction = location.state && location.state.direction;

          var _this16$findViewInfoB2 = _this16.findViewInfoById(_this16.prevViewId, _this16.state.viewStacks),
              prevView = _this16$findViewInfoB2.view;

          _this16.transitionView(activeView.ref.current, prevView && prevView.ref.current || undefined, routerOutlet, direction);
        }
      });
    }
  }, {
    key: "removeViewStack",
    value: function removeViewStack(stack) {
      var viewStacks = Object.assign({}, this.state.viewStacks);
      delete viewStacks[stack];
      this.setState({
        viewStacks: viewStacks
      });
    }
  }, {
    key: "renderChild",
    value: function renderChild(item) {
      var component = React.cloneElement(item.element, {
        computedMatch: item.routeData.match
      });
      return component;
    }
  }, {
    key: "findActiveView",
    value: function findActiveView(views) {
      var _this17 = this;

      var view;
      views.some(function (x) {
        var match = reactRouterDom.matchPath(_this17.props.location.pathname, x.routeData.childProps);

        if (match) {
          view = x;
          return true;
        }

        return false;
      });
      return view;
    }
  }, {
    key: "transitionView",
    value: function transitionView(enteringEl, leavingEl, ionRouterOuter, direction) {
      var _this18 = this;

      /**
       * Super hacky workaround to make sure ionRouterOutlet is available
       * since transitionView might be called before IonRouterOutlet is fully mounted
       */
      if (ionRouterOuter && ionRouterOuter.componentOnReady) {
        this.commitView(enteringEl, leavingEl, ionRouterOuter, direction);
      } else {
        setTimeout(function () {
          _this18.transitionView(enteringEl, leavingEl, ionRouterOuter, direction);
        }, 10);
      }
    }
  }, {
    key: "commitView",
    value: function () {
      var _commitView = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(enteringEl, leavingEl, ionRouterOuter, direction) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return ionRouterOuter.componentOnReady();

              case 2:
                _context6.next = 4;
                return ionRouterOuter.commit(enteringEl, leavingEl, {
                  deepWait: true,
                  duration: direction === undefined ? 0 : undefined,
                  direction: direction,
                  showGoBack: direction === 'forward',
                  progressAnimation: false
                });

              case 4:
                if (leavingEl && enteringEl !== leavingEl) {
                  /**
                   *  add hidden attributes
                  */
                  leavingEl.classList.add('ion-page-hidden');
                  leavingEl.setAttribute('aria-hidden', 'true');
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      return function commitView(_x5, _x6, _x7, _x8) {
        return _commitView.apply(this, arguments);
      };
    }()
  }, {
    key: "render",
    value: function render() {
      return React.createElement(NavContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return IonNavManager;
}(React.Component);

var IonNavManagerWithRouter = reactRouterDom.withRouter(IonNavManager);
IonNavManagerWithRouter.displayName = 'IonNavManager';

var IonReactRouter =
/*#__PURE__*/
function (_React$Component13) {
  _inherits(IonReactRouter, _React$Component13);

  function IonReactRouter() {
    _classCallCheck(this, IonReactRouter);

    return _possibleConstructorReturn(this, _getPrototypeOf(IonReactRouter).apply(this, arguments));
  }

  _createClass(IonReactRouter, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          props = tslib_1.__rest(_a, ["children"]);

      return React.createElement(reactRouterDom.BrowserRouter, Object.assign({}, props), React.createElement(IonNavManagerWithRouter, null, children));
    }
  }]);

  return IonReactRouter;
}(React.Component);

loader.defineCustomElements(window); // Icons that are used by internal components

ionicons.addIcons({
  'ios-close': icons.close.ios,
  'md-close': icons.close.md,
  'ios-reorder': icons.reorder.ios,
  'md-reorder': icons.reorder.md,
  'ios-menu': icons.menu.ios,
  'md-menu': icons.menu.md,
  'ios-arrow-forward': icons.arrowForward.ios,
  'md-arrow-forward': icons.arrowForward.md,
  'ios-arrow-back': icons.arrowBack.ios,
  'md-arrow-back': icons.arrowBack.md,
  'ios-arrow-down': icons.arrowDown.ios,
  'md-arrow-down': icons.arrowDown.md,
  'ios-search': icons.search.ios,
  'md-search': icons.search.md,
  'ios-close-circle': icons.closeCircle.ios,
  'md-close-circle': icons.closeCircle.md
});
exports.IonActionSheet = IonActionSheet;
exports.IonAlert = IonAlert;
exports.IonAnchor = IonAnchor;
exports.IonApp = IonApp;
exports.IonAppInner = IonAppInner;
exports.IonAvatar = IonAvatar;
exports.IonBackButton = IonBackButton;
exports.IonBackButtonInner = IonBackButtonInner;
exports.IonBackdrop = IonBackdrop;
exports.IonBadge = IonBadge;
exports.IonButton = IonButton;
exports.IonButtons = IonButtons;
exports.IonCard = IonCard;
exports.IonCardContent = IonCardContent;
exports.IonCardHeader = IonCardHeader;
exports.IonCardSubtitle = IonCardSubtitle;
exports.IonCardTitle = IonCardTitle;
exports.IonCheckbox = IonCheckbox;
exports.IonChip = IonChip;
exports.IonCol = IonCol;
exports.IonContent = IonContent;
exports.IonDatetime = IonDatetime;
exports.IonFab = IonFab;
exports.IonFabButton = IonFabButton;
exports.IonFabList = IonFabList;
exports.IonFooter = IonFooter;
exports.IonGrid = IonGrid;
exports.IonHeader = IonHeader;
exports.IonIcon = IonIcon;
exports.IonImg = IonImg;
exports.IonInfiniteScroll = IonInfiniteScroll;
exports.IonInput = IonInput;
exports.IonItem = IonItem;
exports.IonItemDivider = IonItemDivider;
exports.IonItemGroup = IonItemGroup;
exports.IonItemOption = IonItemOption;
exports.IonItemOptions = IonItemOptions;
exports.IonItemSliding = IonItemSliding;
exports.IonLabel = IonLabel;
exports.IonLifeCycleContext = IonLifeCycleContext;
exports.IonList = IonList;
exports.IonListHeader = IonListHeader;
exports.IonLoading = IonLoading;
exports.IonMenu = IonMenu;
exports.IonMenuButton = IonMenuButton;
exports.IonMenuToggle = IonMenuToggle;
exports.IonModal = IonModal;
exports.IonNav = IonNav;
exports.IonNote = IonNote;
exports.IonPage = IonPage;
exports.IonPicker = IonPicker;
exports.IonPickerColumn = IonPickerColumn;
exports.IonPopover = IonPopover;
exports.IonProgressBar = IonProgressBar;
exports.IonRadio = IonRadio;
exports.IonRadioGroup = IonRadioGroup;
exports.IonRange = IonRange;
exports.IonReactRouter = IonReactRouter;
exports.IonRefresher = IonRefresher;
exports.IonRefresherContent = IonRefresherContent;
exports.IonReorder = IonReorder;
exports.IonReorderGroup = IonReorderGroup;
exports.IonRippleEffect = IonRippleEffect;
exports.IonRouterOutlet = IonRouterOutlet;
exports.IonRouterOutletInner = IonRouterOutletInner;
exports.IonRow = IonRow;
exports.IonSearchbar = IonSearchbar;
exports.IonSegment = IonSegment;
exports.IonSegmentButton = IonSegmentButton;
exports.IonSelect = IonSelect;
exports.IonSelectOption = IonSelectOption;
exports.IonSelectPopover = IonSelectPopover;
exports.IonSkeletonText = IonSkeletonText;
exports.IonSlide = IonSlide;
exports.IonSlides = IonSlides;
exports.IonSpinner = IonSpinner;
exports.IonSplitPane = IonSplitPane;
exports.IonTab = IonTab;
exports.IonTabBar = IonTabBar;
exports.IonTabBarInner = IonTabBarInner;
exports.IonTabButton = IonTabButton;
exports.IonTabs = IonTabs;
exports.IonText = IonText;
exports.IonTextarea = IonTextarea;
exports.IonThumbnail = IonThumbnail;
exports.IonTitle = IonTitle;
exports.IonToast = IonToast;
exports.IonToggle = IonToggle;
exports.IonToolbar = IonToolbar;
exports.IonVirtualScroll = IonVirtualScroll;
exports.IonicContext = IonicContext;
exports.useIonViewDidEnter = useIonViewDidEnter;
exports.useIonViewDidLeave = useIonViewDidLeave;
exports.useIonViewWillEnter = useIonViewWillEnter;
exports.useIonViewWillLeave = useIonViewWillLeave;
exports.useIonicConfig = useIonicConfig;
exports.withIonLifeCycle = withIonLifeCycle;